/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';

import adminApi from '../../services/admin-api';

import './Modal.css';

const DEFAULT_FORM = {
  expires: 1,
  title: 'System Downtime',
  body:
    'We are currently experiencing an issue with our system and are actively working on resolving the issue. We apologize for any inconvenience this may cause.\nIf you have any questions, please contact us at insights-support@whipmedia.com. Or, of course, feel free to reach out to your CVM Insights representative with any questions.\nThank you,\nThe CVM Insights Team'
};

const DowntimeModal = ({
  isOpen,
  onClose,
  messages,
  downtimeActions: { checkHealthStatus }
}) => {
  const [form, setForm] = useState(DEFAULT_FORM);
  const [errorMessage, setErrorMessage] = useState(false);
  const onCloseModal = () => {
    onClose();
    setForm(DEFAULT_FORM);
  };

  const onClickDisable = msg => async () => {
    const result = await adminApi.disableDowntimeMessage(msg);
    if (result.success) {
      checkHealthStatus();
    } else {
      console.log(result);
    }
  };

  const onChangeInput = key => e => {
    setForm({ ...form, [key]: e.target.value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    const msg = { ...form };
    const msgDate = new Date(Date.now() + msg.expires * 60 * 60 * 1000);
    msg.expires = msgDate.getTime();
    const result = await adminApi.createDowntimeMessage(msg);

    if (result.success) {
      checkHealthStatus();
      setErrorMessage(false);
      onCloseModal();
    } else {
      console.log(result);
      setErrorMessage(
        result.error && result.error.message
          ? result.error.message
          : 'Contact your developer / check console'
      );
    }
  };

  return (
    <Modal
      className="cvmi-admin__edit-user-modal"
      id="cvmi-admin__edit-user-modal"
      show={isOpen}
      onHide={onCloseModal}
      backdrop
    >
      <div className="cvmi-admin__edit-user-modal-row">
        <h1 className="cvmi-admin__h1">Downtime Messages</h1>
      </div>

      <div className="cvmi-admin__edit-user-modal-row">
        <h2 className="cvmi-admin__h2">Active Messages</h2>
      </div>

      <div>
        {messages && messages.length > 0 ? (
          messages.map(msg => {
            const msgDate = new Date(msg.expires);
            return (
              <>
                <div className="cvmi-admin__active-message">
                  <span className="cvmi-admin__active-message-title">
                    {msg.title} -{' '}
                  </span>
                  <span className="cvmi-admin__active-message-body">
                    {`${msg.body.substring(
                      0,
                      msg.body.length > 30 ? 30 : msg.body.length
                    )}${msg.body.length > 30 ? '...' : ''}`}
                  </span>
                  <span className="cvmi-admin__active-message-body-bold">
                    | Expires:
                  </span>
                  <span>{`${msgDate.toLocaleDateString()} ${msgDate.toLocaleTimeString()}`}</span>
                  <button
                    className="cvmi-admin__active-message-disable"
                    onClick={onClickDisable(msg)}
                  >
                    disable
                  </button>
                </div>
              </>
            );
          })
        ) : (
          <div>There are no active messages.</div>
        )}
      </div>

      <div className="cvmi-admin__edit-user-modal-row">
        <h2 className="cvmi-admin__h2">Create Downtime Message</h2>
      </div>
      <div className="cvmi-admin__edit-user-modal-row">
        <form className="cvmi-admin__form" onSubmit={handleSubmit}>
          <div className="cvmi-admin__downtime-modal-title-wrapper">
            <label htmlFor="title">
              TITLE
              <input
                id="title"
                value={form.title}
                onChange={onChangeInput('title')}
              />
            </label>
          </div>
          <div className="cvmi-admin__downtime-modal-expires-wrapper">
            <label htmlFor="expires">
              DURATION (Hours)
              <input
                type="number"
                value={form.expires}
                onChange={onChangeInput('expires')}
              />
            </label>
          </div>
          <div className="cvmi-admin__downtime-modal-body-wrapper">
            <label htmlFor="body">
              Message
              <textarea
                id="body"
                value={form.body}
                onChange={onChangeInput('body')}
              />
            </label>
          </div>
          <button className="cvmi-admin__downtime-submit" type="submit">
            submit
          </button>
        </form>
        {errorMessage !== false ? (
          <div className="cvmi-admin__downtime-error-text">
            Wuh-Woh. Something went wrong: {errorMessage}
          </div>
        ) : null}
      </div>
    </Modal>
  );
};

export default DowntimeModal;
